module.exports = __webpack_public_path__ + "static/img/2021.7.15.917078f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/2021.7.15.jpg
// module id = 89dV
// module chunks = 52